<template>
  <div class="">
    <Title :title="'订单列表'"></Title>
    <el-tabs v-model="activeName" class="tabsStyle" @tab-click="tabClick">
      <el-tab-pane label="肯德基订单" name="kfc">
        <div class="search">
          <div class="flex">
            <p>订单状态</p>
            <div class="status">
              <select class="statusSelect" v-model="search.status">
                <option value="" label="全部"></option>
                <option value="0" label="待支付"></option>
                <option value="10" label="待出票"></option>
                <option value="20" label="已出票"></option>
                <option value="30" label="已完成"></option>
                <option value="100" label="订单关闭"></option>
              </select>
            </div>
          </div>
          <div class="flex">
            <p>会员昵称</p>
            <input type="text" placeholder="会员昵称" class="inputStyle" v-model="search.nickName">
          </div>
          <div class="flex">
            <p>订单编号</p>
            <input type="text" placeholder="订单编号" class="inputStyle" v-model="search.orderNumber">
          </div>
          <div class="flex">
            <p>佣金值</p>
            <input min="0" type="number" placeholder="佣金值" class="inputStyle" v-model="search.minCommission" @blur="orderNumberStartBlur"
              style="margin-right: 10px;">
            <p>至</p>
            <input min="0" type="number" placeholder="佣金值" class="inputStyle" v-model="search.maxCommission" @blur="orderNumberEndBlur">
          </div>
          <div class="flex">
            <p>下单日期</p>
            <DatePicker type="date" placeholder="开始时间" style="width: 150px;margin-right: 10px;margin-bottom: 8px;margin-top: 8px;"
              v-model="search.createTimeStartTime" @on-change="handelDateChangeStart"></DatePicker>
            <p>至</p>
            <DatePicker type="date" placeholder="结束时间" style="width: 150px;margin-bottom: 8px;margin-top: 8px;" v-model="search.createTimeEndTime"
              @on-change="handelDateChangeEnd"></DatePicker>
          </div>
          <div class="flex">
            <div class="searchBtn" @click="queryBtn">查询</div>
            <div class="exportBtn" @click="exportBtn">导出</div>
          </div>
        </div>
        <div class="table">
          <el-table v-loading="listLoading" :data="tableData" style="width: 100%" :highlight-current-row="true"
            :header-cell-style="{background:'#FCFAF8',fontSize: '16px',fontFamily: 'Alibaba-PuHuiTi-R, Alibaba-PuHuiTi',fontWeight: 'normal',color: '#222222'}">
            <el-table-column label="套餐信息" prop="packageInformation" align="center" min-width="160px"></el-table-column>
            <el-table-column label="订单编号" prop="orderNumber" align="center" min-width="160px"></el-table-column>
            <el-table-column label="下单会员" prop="nickName" align="center" min-width="160px"></el-table-column>
            <el-table-column label="下单时间" prop="createTimeStr" align="center" min-width="170px"></el-table-column>
            <el-table-column label="支付金额" prop="payPrice" align="center" min-width="100px"></el-table-column>
            <el-table-column label="订单总佣金" prop="commission" align="center" min-width="100px"></el-table-column>
            <el-table-column label="订单状态" align="statusStr" min-width="100px">
              <template slot-scope="{row}">
                <!-- <div class="status" :class="[{'active0': row.status == 0},{'active1': row.status == 2 || row.status == 3}]">
                  {{row.statusStr }}
                </div> -->
                {{row.statusStr }}
              </template>
            </el-table-column>
            <el-table-column label="结算时间" prop="settleTimeStr" align="center" width="170px"></el-table-column>
          </el-table>
        </div>
        <div class="page">
          <Page v-if="total > 0" :total="total" :current="pageNo" show-sizer show-elevator show-total @on-change="changePage"
            @on-page-size-change="changePagesize"></Page>
        </div>
      </el-tab-pane>
      <el-tab-pane label="电费订单" name="electricity">
        <div class="search">
          <div class="flex">
            <p>订单状态</p>
            <div class="status">
              <select class="statusSelect" v-model="search.showStatus">
                <option value="" label="全部"></option>
                <option value="1" label="待支付"></option>
                <option value="2" label="充值中"></option>
                <option value="3" label="已完成"></option>
                <option value="4" label="已退款"></option>
              </select>
            </div>
          </div>
          <div class="flex">
            <p>会员昵称</p>
            <input type="text" placeholder="会员昵称" class="inputStyle" v-model="search.nickName">
          </div>
          <div class="flex">
            <p>订单编号</p>
            <input type="text" placeholder="订单编号" class="inputStyle" v-model="search.orderNumber">
          </div>
          <div class="flex">
            <p>佣金值</p>
            <input min="0" type="number" placeholder="佣金值" class="inputStyle" v-model="search.minCommission" @blur="orderNumberStartBlur"
              style="margin-right: 10px;">
            <p>至</p>
            <input min="0" type="number" placeholder="佣金值" class="inputStyle" v-model="search.maxCommission" @blur="orderNumberEndBlur">
          </div>
          <div class="flex">
            <p>户号类型</p>
            <div class="status">
              <select class="statusSelect" v-model="search.accountType">
                <option value="" label="全部"></option>
                <option value="1" label="住宅"></option>
                <option value="2" label="店铺"></option>
                <option value="3" label="企业"></option>
              </select>
            </div>
          </div>
          <div class="flex">
            <p>户号</p>
            <input type="text" placeholder="户号" class="inputStyle" v-model="search.account">
          </div>
          <div class="flex">
            <p>下单日期</p>
            <DatePicker type="date" placeholder="开始时间" style="width: 150px;margin-right: 10px;margin-bottom: 8px;margin-top: 8px;"
              v-model="search.createTimeStartTime" @on-change="handelDateChangeStart"></DatePicker>
            <p>至</p>
            <DatePicker type="date" placeholder="结束时间" style="width: 150px;margin-bottom: 8px;margin-top: 8px;" v-model="search.createTimeEndTime"
              @on-change="handelDateChangeEnd"></DatePicker>
          </div>
          <div class="flex">
            <div class="searchBtn" @click="queryBtn">查询</div>
            <div class="exportBtn" @click="exportBtn">导出</div>
          </div>
        </div>
        <div class="table">
          <el-table v-loading="listLoading" :data="tableData" style="width: 100%" :highlight-current-row="true"
            :header-cell-style="{background:'#FCFAF8',fontSize: '16px',fontFamily: 'Alibaba-PuHuiTi-R, Alibaba-PuHuiTi',fontWeight: 'normal',color: '#222222'}">
            <el-table-column label="产品" prop="showPrice" align="center" min-width="160px"></el-table-column>
            <el-table-column label="订单编号" prop="orderNumber" align="center" min-width="160px"></el-table-column>
            <el-table-column label="地区" prop="areaName" align="center" min-width="160px"></el-table-column>
            <el-table-column label="户号类型" prop="accountTypeStr" align="center" min-width="160px"></el-table-column>
            <el-table-column label="户号" prop="account" align="center" min-width="160px"></el-table-column>
            <el-table-column label="下单会员" prop="nickName" align="center" min-width="160px"></el-table-column>
            <el-table-column label="下单时间" prop="createTimeStr" align="center" min-width="160px"></el-table-column>
            <el-table-column label="支付金额" prop="payPrice" align="center" min-width="160px"></el-table-column>
            <el-table-column label="订单佣金" prop="commission" align="center" min-width="160px"></el-table-column>
            <el-table-column label="订单状态" prop="showStatusStr" align="center" min-width="160px"></el-table-column>
            <el-table-column label="结算时间" prop="settleTimeStr" align="center" min-width="160px"></el-table-column>
          </el-table>
        </div>
        <div class="page">
          <Page v-if="total > 0" :total="total" :current="pageNo" show-sizer show-elevator show-total @on-change="changePage"
            @on-page-size-change="changePagesize"></Page>
        </div>
      </el-tab-pane>
      <!-- <el-tab-pane label="肯德基订单" name="kfc2">肯德基订单</el-tab-pane> -->
    </el-tabs>
  </div>
</template>

<script>
import Title from './components/title.vue'
import { DatePicker, Page } from 'view-design'
import { getOrderList, exportOrderList, getElectricityList, exportElectricityList } from '@/api/open.js'
import { getDate } from '@/utils/date'

export default {
  name: '',
  components: { Title, DatePicker, Page },
  props: {},
  data() {
    return {
      activeName: 'kfc',
      search: {
        status: '',
        showStatus: '',
        accountType: ''
      },
      tableData: [],
      total: 0,
      pageNo: 1,
      pageSize: 10,
      listLoading: false
    }
  },
  computed: {},
  watch: {},
  created() {
    // this.$store.commit('nav/SET_ACTIVE_slideActive', 2)
    if (this.$store.getters.appKey.length === 0 && this.$store.getters.userToken !== '') {
      this.$message.warning('请先添加公众号')
      this.$router.push('/pc/open/application')
    }
    if (this.$store.getters.appKey.length > 0) {
      this.getList()
    }
  },
  mounted() {},
  activated() {},
  deactivated() {},
  destroyed() {},
  methods: {
    tabClick() {
      this.search = this.$options.data().search
      this.tableData = this.$options.data().tableData
      this.queryBtn()
    },
    getList() {
      this.listLoading = true
      let userParam = {
        createTimeEndTime: getDate(this.search.createTimeEndTime),
        createTimeStartTime: getDate(this.search.createTimeStartTime)
      }
      if (userParam.createTimeStartTime) {
        userParam.createTimeStartTime = userParam.createTimeStartTime + ' 00:00:00'
      } else {
        delete userParam.createTimeStartTime
      }
      if (userParam.createTimeEndTime) {
        userParam.createTimeEndTime = userParam.createTimeEndTime + ' 23:59:59'
      } else {
        delete userParam.createTimeEndTime
      }

      switch (this.activeName) {
        case 'kfc':
          getOrderList({
            ...userParam,
            appKey: this.$store.getters.showAppKey.appKey,
            status: this.search.status,
            nickName: this.search.nickName,
            orderNumber: this.search.orderNumber,
            minCommission: this.search.minCommission,
            maxCommission: this.search.maxCommission,
            pageNo: this.pageNo,
            pageSize: this.pageSize
          })
            .then(res => {
              console.log('res', res)
              this.tableData = res.data.list
              if (res.data.pageNo === 0) {
                this.total = 0
                this.pageNo = 1
              } else {
                this.total = res.data.total
                this.pageNo = res.data.pageNo
                this.pageSize = res.data.pageSize
              }
              this.listLoading = false
            })
            .catch(err => {
              this.tableData = []
              this.listLoading = false
              this.total = 0
              this.pageNo = 1
            })
          break
        case 'electricity':
          getElectricityList({
            // ...userParam,
            appKey: this.$store.getters.showAppKey.appKey,
            createStartTime: userParam.createTimeStartTime,
            createEndTime: userParam.createTimeEndTime,
            account: this.search.account,
            accountType: this.search.accountType,
            showStatus: this.search.showStatus,
            minCommission: this.search.minCommission,
            maxCommission: this.search.maxCommission,
            nickName: this.search.nickName,
            orderNumber: this.search.orderNumber,
            pageNo: this.pageNo,
            pageSize: this.pageSize
          })
            .then(res => {
              console.log('res', res)
              this.tableData = res.data.list
              if (res.data.pageNo === 0) {
                this.total = 0
                this.pageNo = 1
              } else {
                this.total = res.data.total
                this.pageNo = res.data.pageNo
                this.pageSize = res.data.pageSize
              }
              this.listLoading = false
            })
            .catch(err => {
              this.tableData = []
              this.listLoading = false
              this.total = 0
              this.pageNo = 1
            })
          break

        default:
          break
      }
    },
    //查询
    queryBtn() {
      console.log('search', this.search)
      this.pageNo = 1
      this.getList()
    },
    //导出
    exportBtn() {
      console.log('导出', this.search)
      this.$message.success('开始导出...')
      let userParam = {
        createTimeEndTime: getDate(this.search.createTimeEndTime),
        createTimeStartTime: getDate(this.search.createTimeStartTime)
      }
      if (userParam.createTimeStartTime) {
        userParam.createTimeStartTime = userParam.createTimeStartTime + ' 00:00:00'
      } else {
        delete userParam.createTimeStartTime
      }
      if (userParam.createTimeEndTime) {
        userParam.createTimeEndTime = userParam.createTimeEndTime + ' 23:59:59'
      } else {
        delete userParam.createTimeEndTime
      }

      switch (this.activeName) {
        case 'kfc':
          exportOrderList({
            ...userParam,
            appKey: this.$store.getters.showAppKey.appKey,
            status: this.search.status,
            nickName: this.search.nickName,
            orderNumber: this.search.orderNumber,
            minCommission: this.search.minCommission,
            maxCommission: this.search.maxCommission
          })
          break
        case 'electricity':
          exportElectricityList({
            // ...userParam,
            appKey: this.$store.getters.showAppKey.appKey,
            createStartTime: userParam.createTimeStartTime,
            createEndTime: userParam.createTimeEndTime,
            account: this.search.account,
            accountType: this.search.accountType,
            status: this.search.status,
            minCommission: this.search.minCommission,
            maxCommission: this.search.maxCommission,
            nickName: this.search.nickName,
            orderNumber: this.search.orderNumber
          })
          break

        default:
          break
      }
    },
    handleOrderExport() {},
    formateInit(formData) {
      let objCopy = {}
      for (let key in formData) {
        if (formData[key]) {
          objCopy[key] = formData[key]
        }
      }
      return objCopy
    },
    handelDateChangeStart(time, type) {
      if (type == 'date') {
        if (this.search.timeEnd !== '') {
          if (this.compareTime(time, this.search.timeEnd)) {
            this.search.timeStart = this.search.timeEnd
          }
        }
      }
    },
    handelDateChangeEnd(time, type) {
      if (type == 'date') {
        if (this.search.timeStart !== '') {
          if (this.compareTime(this.search.timeStart, time)) {
            this.search.timeEnd = this.search.timeStart
          }
        }
      }
    },
    compareTime(startTime, endTime) {
      var oDate1 = new Date(startTime)
      var oDate2 = new Date(endTime)
      if (oDate1.getTime() > oDate2.getTime()) {
        return true
      } else {
        return false
      }
    },
    orderNumberStartBlur() {
      if (this.search.orderNumberEnd) {
        if (this.search.orderNumberStart > this.search.orderNumberEnd) {
          this.search.orderNumberStart = this.search.orderNumberEnd
        }
      }
    },
    orderNumberEndBlur() {
      if (this.search.orderNumberStart) {
        if (this.search.orderNumberStart > this.search.orderNumberEnd) {
          this.search.orderNumberEnd = this.search.orderNumberStart
        }
      }
    },
    changePage(value) {
      console.log(value)
      this.pageNo = value
      this.getList()
    },
    changePagesize(value) {
      console.log(value)
      this.pageSize = value
      this.getList()
    }
  }
}
</script>
<style lang='less' scoped>
.tabsStyle {
  margin-top: 15px;
  /deep/ .el-tabs__item.is-active {
    color: #ff8622;
  }
  /deep/ .el-tabs__item:hover {
    color: #ff8622;
  }
  /deep/ .el-tabs__active-bar {
    background-color: #ff8622;
  }
  /deep/ .el-tabs__header {
    margin: 0;
  }

  .search {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    // justify-content: space-between;
    margin-top: 20px;

    p {
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #666666;
      margin-right: 10px;
    }
    ::placeholder {
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #c1c1c1;
    }
    .inputStyle {
      box-sizing: border-box;
      width: 150px;
      height: 32px;
      background: #ffffff;
      border-radius: 2px;
      border: 1px solid #eeeeee;
      padding-left: 10px;
      margin-right: 20px;
      margin-bottom: 8px;
      margin-top: 8px;
    }
    :hover {
      border-color: #57a3f3;
    }
    .searchBtn {
      width: 90px;
      height: 32px;
      background: #ff8622;
      border-radius: 2px;
      text-align: center;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      line-height: 32px;
      color: rgba(255, 255, 255, 0.8);
      // margin-top: 16px;
      margin-left: 20px;
      margin-bottom: 8px;
      margin-top: 8px;
      cursor: pointer;
    }
    .exportBtn {
      width: 90px;
      height: 32px;
      background: #fff;

      border: 1px solid #ff8622;
      border-radius: 2px;
      text-align: center;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      line-height: 32px;
      color: #ff8622;
      // margin-top: 16px;
      margin-left: 20px;
      margin-bottom: 8px;
      margin-top: 8px;
      cursor: pointer;
    }
    .statusSelect {
      width: 150px;
      height: 32px;
      background: #ffffff;
      border-radius: 2px;
      border: 1px solid #eeeeee;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #666666;
      margin-right: 20px;
      padding-left: 10px;
      // padding-right: 10px;
    }
  }
  .table {
    border: 1px solid #eeeeee;
    margin-top: 30px;
    .status {
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #666666;
    }
    .active0 {
      color: #ff4f76;
    }
    .active1 {
      color: #ff8622;
    }
  }
  .page {
    // margin: 0 auto;
    margin-top: 20px;
    margin-bottom: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.flex {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/open/order.vue